import { SEARCH_PLACE_TYPES } from '@web-platform/shared-universal-constants/src/places';
import { TRIP_TYPES } from '@web-platform/shared-universal-constants/src/tripTypes';
import { CONFIG_SERVICE_KEYS } from '@web-platform/shared-universal-constants-config';
import { isSameDay } from 'date-fns/isSameDay';

import { getConfigServiceValue } from '../config';

import type { TripType } from '@web-platform/shared-universal-constants/src/tripTypes';
import type { ContextCulture, SearchPlace } from '@web-platform/shared-universal-types/src/context';
import type { SearchPlaceType } from '@web-platform/shared-universal-types/src/requestContext';

const ALLOWED_TRIP_TYPES: TripType[] = [TRIP_TYPES.RETURN];
const ALLOWED_DESTINATION_TYPES: SearchPlaceType[] = [
  SEARCH_PLACE_TYPES.CITY,
  SEARCH_PLACE_TYPES.AIRPORT,
];

export type PackagesEligibilityArgs = {
  destination?: SearchPlace;
  origin?: SearchPlace;
  tripType: TripType;
  culture: ContextCulture;
  outboundDate: string;
  inboundDate?: string;
};

export const isPackagesSearchEligible = (args: PackagesEligibilityArgs) => {
  const disallowedDestinationCountries =
    getConfigServiceValue(CONFIG_SERVICE_KEYS.OPS.PACKAGES_DISALLOWED_DESTINATION_COUNTRIES)?.split(
      ',',
    ) ?? [];
  const allowedDestinations =
    getConfigServiceValue(CONFIG_SERVICE_KEYS.OPS.PACKAGES_ALLOWED_DESTINATIONS)?.split(',') ?? [];
  const packagesMarketsEnabled =
    getConfigServiceValue(CONFIG_SERVICE_KEYS.OPS.PACKAGES_MARKETS_ENABLED)?.split(',') ?? [];

  const isAllowedDestinationCountry = args.destination?.countryId
    ? !disallowedDestinationCountries.includes(args.destination.countryId)
    : true;
  const isAllowedDestination = args.destination?.id
    ? allowedDestinations.includes(args.destination.id)
    : false;
  const isAllowedDestinationType = args.destination?.type
    ? ALLOWED_DESTINATION_TYPES.includes(args.destination.type)
    : false;
  const isAllowedTripType = ALLOWED_TRIP_TYPES.includes(args.tripType);
  const isAllowedMarket = args.culture.market
    ? packagesMarketsEnabled.includes(args.culture.market)
    : false;
  const isNotSameDayReturn = args.inboundDate
    ? !isSameDay(args.outboundDate, args.inboundDate)
    : false;

  return (
    isAllowedDestinationCountry &&
    isAllowedDestination &&
    isAllowedDestinationType &&
    isAllowedTripType &&
    isAllowedMarket &&
    isNotSameDayReturn
  );
};
